import type React from 'react';
import {
  useVehicleHref,
  useSetSearchRequestIdCookie
} from '@/srp/SearchResults/ResultTile/helpers/ResultTile.helpers';
import { useTileDataContext } from '~/context/srp/TileDataContext';
import { useNativeVDPPayload } from '~/native/srp';
import useSendTileInfoEvent from './useSendTileInfoEvent';

type OwnProps = React.PropsWithChildren<{}>;

const TileContainer = ({ children }: OwnProps) => {
  const { tileData } = useTileDataContext();
  const href = useVehicleHref(tileData);
  const setSearchRequestCookieId = useSetSearchRequestIdCookie();
  const sendTileInfoEvent = useSendTileInfoEvent();
  const nativePayload = useNativeVDPPayload(tileData.vehicleId);

  const handleOnClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    if (Object.keys(tileData).length === 0) return e.preventDefault();
    setSearchRequestCookieId();
    sendTileInfoEvent(tileData);
  };

  return (
    <div
      className="group/main m:border m:border-grey-2 m:border-solid m:h-[397px] m:min-h-[365px] m:rounded-[6px]"
      data-qa="result-tile"
      id={`vehicle-${tileData?.vehicleId}`}
    >
      <a
        // update text-[#702682] to text-grape-600 when @carvana/merch-tailwind updated to helios styles
        className="hover:text-blue-6 hover:visited:text-[#702682] text-blue-6 visited:text-[#702682]"
        href={href}
        onClick={handleOnClick}
        data-analytics-id={null}
        data-native-payload={nativePayload}
      >
        <div className="bg-white grid grid-cols-1 grid-rows-[180px_1fr] group-hover/main:shadow-[0px_6px_13px_rgba(24,53,88,0.1)] h-full overflow-hidden rounded-[6px] shadow-[0px_2px_3px_rgba(24,53,88,0.1)] w-full">
          {children}
        </div>
      </a>
    </div>
  );
};

export default TileContainer;
